export const DEFAULT_URL = 'https://geth.a.exodus.io/wallet/v1/proxy';
